import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getContractDepthRequested } from "../../redux/actions/sessions";
import { getActiveOffersRequested } from "../../redux/actions/offers";
import Button from "../Button";
import { Input, Select } from "../Inputs";
import LabelValue from "../LabelValue";
import Modal from "../../components/Modal";
import TitleValue from "../../components/TitleValue";
import DataTable from "../../components/DataTable";
import { priceParse } from "../../helpers/parsing";
import ModalConfirmation from "../Modal/ModalConfirmation";
import { API_GET, API_POST } from "../../helpers/api";
import { setNotification } from "../../helpers/notification";
import ComboBoxStation from "../ComboBoxStation/ComboBoxStation";
import moment from "moment";
import ModalCertificate from "../Modal/ModalCertificate";
import { monthsAndResourceTypes } from "../../constants/translations";
import PriceInput from "../Inputs/PriceInput";
import {
  convertAmountToFrontend,
  convertNumberToFrontend,
} from "../../helpers/convert";

export default function OfferTab(props) {
  const { t, selectedOrganization, isAdmin, organizationBuyLimit } = props;
  const dispatch = useDispatch();

  const selectedContract = useSelector(
    (state) => state.sessions.selectedContract
  );
  const currentSession = useSelector((state) => state.sessions.current);
  const [selectedFilter, setSelectedFilter] = useState({
    station: "",
    period: "",
  });
  const [offerType, setOfferType] = useState("BUY");
  const [selectedCertificates, setSelectedCertificates] = useState([]);
  const [sellOfferData, setSellOfferData] = useState({
    offerType: "STANDART",
    offerStatus: "OPEN",
    price: null,
  });
  const [buyOfferData, setBuyOfferData] = useState({
    offerType: "STANDART",
    offerStatus: "OPEN",
    quantity: null,
    price: null,
  });
  const [giveOfferConfirmation, setGiveOfferConfirmation] = useState(false);
  const [offerRequestLoading, setOfferRequestLoading] = useState(false);
  const [modalSellOffer, setModalSellOffer] = useState(false);
  const [inspectedCertificateId, setInspectedCertificateId] = useState();
  const [activeCertificates, setActiveCertificates] = useState([]);

  const translations = monthsAndResourceTypes(t);

  const activeCertificatesColumns = [
    {
      name: t("pages.default.certificates.table.stationName"),
      selector: "stationName",
      sortable: true,
    },
    {
      name: t("pages.default.certificates.table.resourceType"),
      selector: "resourceType",
      sortable: true,
      cell: (row) => {
        return translations[row.resourceType];
      },
    },
    {
      name: t("pages.default.certificates.table.productionPeriod"),
      selector: "productionPeriod",
      sortable: true,
      cell: (row) => {
        return `${translations[row.productionMonth]}/${row.productionYear}`;
      },
    },
    {
      name: t("pages.default.certificates.table.documentCount"),
      selector: "totalAmount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.totalAmount);
      },
    },
    {
      name: t("pages.default.certificates.table.process"),
      selector: "stationId",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              suffixIcon="search"
              type="secondary"
              onClick={() => setInspectedCertificateId(row.id)}
            />
            <Button
              suffixIcon="plus"
              type="primary"
              onClick={() => selectCertificate(row)}
              disabled={selectCertificateIsDisabled(row)}
            />
          </div>
        );
      },
    },
  ];
  const selectedCertificatesColumns = [
    {
      name: t("pages.default.certificates.table.stationName"),
      selector: "stationName",
      sortable: true,
    },
    {
      name: t("pages.default.certificates.table.resourceType"),
      selector: "resourceType",
      sortable: true,
      cell: (row) => {
        return translations[row.resourceType];
      },
    },
    {
      name: t("pages.default.certificates.table.productionPeriod"),
      selector: "productionPeriod",
      sortable: true,
      cell: (row) => {
        return `${translations[row.productionMonth]}/${row.productionYear}`;
      },
    },
    {
      name: t("pages.default.certificates.table.documentCount"),
      selector: "documentCount",
      sortable: true,
      cell: (row) => {
        return (
          <Input
            type="number"
            placeholder={`Max ${row.amount}`}
            value={row.sellAmount}
            onChange={(e) => rowSellAmountChange(e, row)}
            max={row.amount}
            min={1}
          />
        );
      },
    },
    {
      name: t("pages.default.certificates.table.process"),
      selector: "stationId",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              suffixIcon="minus"
              type="destructive"
              onClick={() => removeCertificate(row)}
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getActiveCertificates();
    setSelectedCertificates([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedContract, selectedOrganization]);

  useEffect(() => {}, [sellOfferData, buyOfferData]);

  const getActiveCertificates = async () => {
    let activeCerts = await API_GET("certificate", {
      organizationId: selectedOrganization.organizationId,
      stationId:
        selectedFilter.station && selectedFilter.station.stationId
          ? selectedFilter.station.stationId
          : "",
      resourceType: selectedContract.type,
      month: selectedFilter.period
        ? moment(selectedFilter.period).format("M")
        : "",
      year: selectedFilter.period
        ? moment(selectedFilter.period).format("YYYY")
        : "",
      certificateStatus: "ACTIVE",
      dontShowOutOfDate: true,
      size: 1000,
    });
    let activeCertsSaved = activeCerts.data.items.reduce((acc, value) => {
      acc.push({
        ...value,
        stationId: value.productionData.station.stationId,
        stationName: value.productionData.station.stationName,
        productionMonth: moment(value.productionData.term).format("M"),
        productionYear: moment(value.productionData.term).format("YYYY"),
        productionPeriod: value.productionData.term,
        totalAmount: value.amount,
      });
      return acc;
    }, []);
    setActiveCertificates(activeCertsSaved);
  };

  const periodChange = (e) => {
    setSelectedFilter({
      ...selectedFilter,
      period: e.target.value,
    });
  };
  const stationChange = (e) => {
    setSelectedFilter({
      ...selectedFilter,
      station: e,
    });
  };

  const selectCertificate = (row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    certificates.push({ ...row, sellAmount: "" });
    certificates.sort((a, b) => {
      var aP = a.productionPeriod,
        bP = b.productionPeriod;

      return aP && bP
        ? a.productionPeriod.localeCompare(b.productionPeriod)
        : aP - bP;
    });
    setSelectedCertificates(certificates);
  };

  const removeCertificate = (row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    let deletedCertificateIndex = certificates.findIndex((certificate) => {
      return certificate.id === row.id;
    });
    // deep copy
    let listedCerts = JSON.parse(JSON.stringify(activeCertificates));
    // eslint-disable-next-line array-callback-return
    listedCerts.map((item) => {
      if (item.id === row.id) {
        item.totalAmount = item.amount;
      }
    });
    certificates.splice(deletedCertificateIndex, 1);
    setSelectedCertificates(certificates);
    setActiveCertificates(listedCerts);
  };

  const selectCertificateIsDisabled = (row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    let certificate = certificates.filter((certificate) => {
      return certificate.id === row.id;
    });
    return certificate[0];
  };

  const rowSellAmountChange = (e, row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    let listedCerts = JSON.parse(JSON.stringify(activeCertificates));
    // eslint-disable-next-line array-callback-return
    listedCerts.map((item) => {
      if (item.id === row.id) {
        item.totalAmount =
          item.amount - parseInt(e.target.value ? e.target.value : 0);
      }
    });
    // eslint-disable-next-line array-callback-return
    certificates.map((certificate) => {
      if (certificate.id === row.id) {
        certificate.sellAmount = parseInt(e.target.value ? e.target.value : 0);
      }
    });
    setActiveCertificates(listedCerts);
    setSelectedCertificates(certificates);
  };

  const giveBuyOfferRequest = async () => {
    let createOffer = {
      deleteRequests: [],
      updateRequests: [],
      createRequests: [],
      passiveRequests: [],
      activeRequests: [],
    };
    try {
      setOfferRequestLoading(true);
      let requestBody;
      if (selectedOrganization) {
        requestBody = [
          {
            organizationId: selectedOrganization.organizationId,
            contractId: selectedContract.id,
            exchangeOrderType: "BUY",
            exchangeOrderStatus: buyOfferData.offerStatus,
            term: currentSession.sessionDate,
            amount: buyOfferData.quantity,
            price: buyOfferData.price,
          },
        ];
      } else {
        requestBody = [
          {
            contractId: selectedContract.id,
            exchangeOrderType: "BUY",
            exchangeOrderStatus: buyOfferData.offerStatus,
            term: currentSession.sessionDate,
            amount: buyOfferData.quantity,
            price: buyOfferData.price,
          },
        ];
      }
      createOffer.createRequests = requestBody;
      await API_POST("exchange-order/multi", createOffer);
      setBuyOfferData({
        offerType: "STANDART",
        offerStatus: "OPEN",
        quantity: 0,
        price: 0,
      });
      // get contract depth and active offers again
      if (isAdmin) {
        dispatch(
          getContractDepthRequested({ contractId: selectedContract.id })
        );
        dispatch(getActiveOffersRequested({ contractId: selectedContract.id }));
      } else {
        dispatch(
          getContractDepthRequested({
            contractId: selectedContract.id,
            systemParticipant: true,
          })
        );
        dispatch(
          getActiveOffersRequested({
            contractId: selectedContract.id,
            organizationId: selectedOrganization.organizationId,
          })
        );
      }
      setOfferRequestLoading(false);
      setGiveOfferConfirmation(false);
      setNotification(
        "success",
        t("pages.default.offerOperations.success.give")
      );
    } catch (err) {
      setNotification("error", err.response.data.message);
      setOfferRequestLoading(false);
    }
  };

  const giveSellOfferRequest = async () => {
    let createOffer = {
      deleteRequests: [],
      updateRequests: [],
      createRequests: [],
      passiveRequests: [],
      activeRequests: [],
    };
    try {
      setOfferRequestLoading(true);
      let requestBody;
      if (selectedOrganization) {
        requestBody = selectedCertificates.reduce((acc, item) => {
          acc.push({
            organizationId: selectedOrganization
              ? selectedOrganization.organizationId
              : "",
            certificateId: item.id,
            contractId: selectedContract.id,
            exchangeOrderStatus: sellOfferData.offerStatus,
            exchangeOrderType: "SELL",
            term: currentSession.sessionDate,
            amount: item.sellAmount,
            price: sellOfferData.price,
          });
          return acc;
        }, []);
      } else {
        requestBody = selectedCertificates.reduce((acc, item) => {
          acc.push({
            certificateId: item.id,
            contractId: selectedContract.id,
            exchangeOrderStatus: sellOfferData.offerStatus,
            exchangeOrderType: "SELL",
            term: currentSession.sessionDate,
            amount: item.sellAmount,
            price: sellOfferData.price,
          });
          return acc;
        }, []);
      }
      createOffer.createRequests = requestBody;
      await API_POST("exchange-order/multi", createOffer);
      // clear offer inputs
      setSellOfferData({
        offerType: "STANDART",
        offerStatus: "OPEN",
        price: 0,
      });
      // get active certificates
      getActiveCertificates();
      // get contract depth and active offers again
      if (isAdmin) {
        dispatch(
          getContractDepthRequested({ contractId: selectedContract.id })
        );
        dispatch(getActiveOffersRequested({ contractId: selectedContract.id }));
      } else {
        dispatch(
          getContractDepthRequested({
            contractId: selectedContract.id,
            systemParticipant: true,
          })
        );
        dispatch(
          getActiveOffersRequested({
            contractId: selectedContract.id,
            organizationId: selectedOrganization.organizationId,
          })
        );
      }
      setOfferRequestLoading(false);
      setGiveOfferConfirmation(false);
      // remove selected certificates
      setSelectedCertificates([]);
      setNotification(
        "success",
        t("pages.default.offerOperations.success.give")
      );
    } catch (err) {
      setNotification("error", err.response.data.message);
      setOfferRequestLoading(false);
    }
  };

  const modalSellOfferToggle = () => {
    let certificatesHasNullAmount = selectedCertificates.map((item) => {
      if (!item.sellAmount) {
        return true;
      }
      return false;
    });
    if (certificatesHasNullAmount.includes(true)) {
      setNotification("error", "Lütfen bütün sertifikalara miktar giriniz");
      return false;
    }
    setModalSellOffer(false);
  };
  const validateBuyOfferRequest = () => {
    if (!selectedOrganization.marketParticipationAgreement) {
      setNotification(
        "error",
        "Seçtiğiniz organizasyonun organize piyasa katılım anlaşması bulunmamaktadır!"
      );
      return false;
    }
    if (!buyOfferData.quantity) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.amount")
      );
      return false;
    }
    if (!buyOfferData.price) {
      setNotification("error", t("pages.default.offerOperations.errors.price"));
      return false;
    }
    if (buyOfferData.price < selectedContract.minPrice) {
      setNotification(
        "error",
        `Fiyat (TL/Adet) için Minimum ${selectedContract.minPrice} girebilirsiniz.`
      );
      return false;
    }
    if (buyOfferData.price > selectedContract.maxPrice) {
      setNotification(
        "error",
        `Fiyat (TL/Adet) için Maximum ${selectedContract.maxPrice} girebilirsiniz.`
      );
      return false;
    }
    return true;
  };
  const validateSellOfferRequest = () => {
    if (!selectedOrganization.marketParticipationAgreement) {
      setNotification(
        "error",
        "Seçtiğiniz organizasyonun organize piyasa katılım anlaşması bulunmamaktadır!"
      );
      return false;
    }
    if (!sellOfferData.price) {
      setNotification("error", t("pages.default.offerOperations.errors.price"));
      return false;
    }
    if (sellOfferData.price < selectedContract.minPrice) {
      setNotification(
        "error",
        `Fiyat (TL/Adet) için Minimum ${selectedContract.minPrice} girebilirsiniz.`
      );
      return false;
    }
    if (sellOfferData.price > selectedContract.maxPrice) {
      setNotification(
        "error",
        `Fiyat (TL/Adet) için Maximum ${selectedContract.maxPrice} girebilirsiniz.`
      );
      return false;
    }
    if (selectedCertificates.length === 0) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.editSellNoCertificatesSelected")
      );
      return false;
    }
    let certificatesHasNullAmount = selectedCertificates.map((item) => {
      if (!item.sellAmount) {
        return true;
      }
      return false;
    });
    if (certificatesHasNullAmount.includes(true)) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.editSellFillAllCertificates")
      );
      return false;
    }
    return true;
  };
  const offerConfirmationToggle = () => {
    if (offerType === "BUY") {
      if (validateBuyOfferRequest()) setGiveOfferConfirmation(true);
      return;
    }
    if (offerType === "SELL") {
      if (validateSellOfferRequest()) setGiveOfferConfirmation(true);
      return;
    }
  };
  const giveOfferRequest = async () => {
    if (offerType === "BUY") {
      if (validateBuyOfferRequest()) await giveBuyOfferRequest();
      return true;
    }
    if (offerType === "SELL") {
      if (validateSellOfferRequest()) await giveSellOfferRequest();
      return true;
    }
  };
  const selectCertificateModal = async () => {
    try {
      await getActiveCertificates();
      setModalSellOffer(true);
    } catch (err) {}
  };

  const inputChange = (e) => {
    const { name, value } = e.target;
    if (offerType === "BUY") {
      setBuyOfferData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setSellOfferData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  return (
    <>
      <div className="km__c--offer-tab-container">
        <div className="km__c--offer-tab-header">
          <div
            className={`km__c--offer-tab-header-buy ${
              offerType === "BUY" ? "km__c--offer-tab-header-selected" : ""
            }`}
            onClick={() => setOfferType("BUY")}
          >
            {t("pages.default.offerOperations.buy")}
          </div>
          <div
            className={`km__c--offer-tab-header-sell ${
              offerType === "SELL" ? "km__c--offer-tab-header-selected" : ""
            }`}
            onClick={() => setOfferType("SELL")}
          >
            {t("pages.default.offerOperations.sell")}
          </div>
        </div>
        <div className="km__c--offer-tab-body">
          {offerType === "BUY" ? (
            <>
              <div className="km__c--offer-tab-body-row">
                <Select
                  label={t("pages.default.offerOperations.orderType")}
                  options={[
                    {
                      name: t("ui.default.offerTab.standart"),
                      value: "STANDART",
                    },
                  ]}
                  defaultValue={buyOfferData.offerType}
                  name="offerType"
                  onChange={(e) => inputChange(e)}
                />
                <Select
                  label={t("pages.default.offerOperations.orderStatus")}
                  options={[
                    {
                      name: t("pages.default.offerOperations.active"),
                      value: "OPEN",
                    },
                    {
                      name: t("pages.default.offerOperations.passive"),
                      value: "DRAFT",
                    },
                  ]}
                  value={buyOfferData.offerStatus}
                  name="offerStatus"
                  onChange={(e) => inputChange(e)}
                />
              </div>
              <div className="km__c--offer-tab-body-row">
                <Input
                  label={t("pages.default.offerOperations.amount")}
                  value={buyOfferData.quantity}
                  name="quantity"
                  min="1"
                  type="number"
                  onChange={(e) => inputChange(e)}
                />
                <PriceInput
                  label={t("pages.default.offerOperations.price")}
                  value={buyOfferData.price}
                  name="price"
                  min={selectedContract.minPrice}
                  max={selectedContract.maxPrice}
                  type="number"
                  acceptDecimal
                  onChange={(e) => inputChange(e)}
                />
              </div>
              <div className="km__c--offer-tab-body-row">
                <LabelValue
                  label={t("pages.default.offerOperations.orderLimit")}
                  value={convertNumberToFrontend({
                    num: organizationBuyLimit ? organizationBuyLimit : 0,
                    digit: 2,
                  })}
                />
                <LabelValue
                  label={t("pages.default.offerOperations.totalPrice")}
                  value={convertNumberToFrontend({
                    num: buyOfferData.price * buyOfferData.quantity,
                    digit: 2,
                  })}
                />
              </div>
              <div className="km__c--offer-tab-body-action">
                <Button
                  type="primary"
                  onClick={offerConfirmationToggle}
                  label={t("pages.default.offerOperations.submitOrder")}
                />
              </div>
            </>
          ) : (
            <>
              <div className="km__c--offer-tab-body-row">
                <LabelValue
                  label={t("pages.default.offerOperations.chooseCertificate")}
                  value={
                    <Button
                      className="km__c--button km__c--button-is-secondary w-100"
                      type="secondary"
                      onClick={selectCertificateModal}
                      label={t(
                        "pages.default.offerOperations.chooseCertificate"
                      )}
                    />
                  }
                />
                <Select
                  label={t("pages.default.offerOperations.orderStatus")}
                  options={[
                    {
                      name: t("pages.default.offerOperations.active"),
                      value: "OPEN",
                    },
                    {
                      name: t("pages.default.offerOperations.passive"),
                      value: "DRAFT",
                    },
                  ]}
                  value={sellOfferData.offerStatus}
                  name="offerStatus"
                  onChange={(e) => inputChange(e)}
                />
              </div>
              <div className="km__c--offer-tab-body-row">
                <Select
                  label={t("pages.default.offerOperations.orderType")}
                  options={[
                    {
                      name: t("ui.default.offerTab.standart"),
                      value: "STANDART",
                    },
                  ]}
                  defaultValue={sellOfferData.offerType}
                  name="offerType"
                  onChange={(e) => inputChange(e)}
                />
                <PriceInput
                  label={t("pages.default.offerOperations.price")}
                  type="number"
                  min={selectedContract.minPrice}
                  max={selectedContract.maxPrice}
                  name="price"
                  acceptDecimal
                  value={sellOfferData.price}
                  onChange={(e) => inputChange(e)}
                />
              </div>
              <div className="km__c--offer-tab-body-row">
                <LabelValue
                  label={t("pages.default.offerOperations.amount")}
                  value={convertAmountToFrontend(
                    selectedCertificates.reduce((acc, certificate) => {
                      acc += certificate.sellAmount;
                      return acc;
                    }, 0)
                  )}
                />
                <LabelValue
                  label={t("pages.default.offerOperations.totalPrice")}
                  value={convertNumberToFrontend({
                    num:
                      sellOfferData.price *
                      selectedCertificates.reduce((acc, certificate) => {
                        acc += certificate.sellAmount;
                        return acc;
                      }, 0),
                    digit: 2,
                  })}
                />
              </div>
              <div className="km__c--offer-tab-body-action">
                <Button
                  type="primary"
                  onClick={offerConfirmationToggle}
                  label={t("pages.default.offerOperations.submitOrder")}
                />
              </div>
            </>
          )}
        </div>
      </div>
      {/* Confirmation Modal */}
      <ModalConfirmation
        isOpen={giveOfferConfirmation}
        toggle={() => setGiveOfferConfirmation(false)}
        header={t(
          "pages.default.offerOperations.confirmations.offerTransaction.title"
        )}
        body={
          offerType === "BUY"
            ? t(
                "pages.default.offerOperations.confirmations.offerTransaction.description.buy"
              )
            : t(
                "pages.default.offerOperations.confirmations.offerTransaction.description.sell"
              )
        }
        approve={giveOfferRequest}
        loading={offerRequestLoading}
      />
      {/* Sell offer document selection */}
      <Modal
        isOpen={modalSellOffer}
        toggle={setModalSellOffer}
        className="km__p--modal-edit-sell-offer"
      >
        <div className="km__p-modal-edit-sell-offer-body">
          <p className="km__u--text_title">
            {t("pages.default.bilateralAgreements.activeCertificates")}
          </p>
          <div className="km__p-modal-edit-sell-offer-body-filter">
            <ComboBoxStation
              t={t}
              selectedStation={selectedFilter.station}
              selectStation={stationChange}
            />
            <Input
              type="month"
              name="period"
              placeholder={t(
                "pages.default.certificates.table.productionPeriod"
              )}
              value={selectedFilter.period}
              onChange={periodChange}
            />
            <Button
              label={t("pages.default.exportTransactions.filter")}
              type="primary"
              onClick={getActiveCertificates}
            />
          </div>
          <DataTable
            columns={activeCertificatesColumns}
            data={activeCertificates}
            rowKey="id"
            defaultSortAsc={false}
            defaultSortedField="productionPeriod"
            paginationPerPage={5}
            pagination
          />
          {selectedCertificates.length > 0 && (
            <>
              <p className="km__u--text_title">
                Satışa Sunulacak YEK-G Belgeleri
              </p>
              <DataTable
                columns={selectedCertificatesColumns}
                data={selectedCertificates}
                rowKey="id"
                paginationPerPage={5}
                pagination
              />
              <div className="km__p-modal-edit-sell-offer-body-total">
                <TitleValue
                  size="lg"
                  title="Toplam YEK-G Belge Miktarı"
                  value={convertAmountToFrontend(
                    selectedCertificates.reduce((acc, certificate) => {
                      acc +=
                        Number(certificate?.sellAmount) &&
                        certificate?.sellAmount;
                      return acc;
                    }, 0)
                  )}
                />
              </div>
              <div className="km__p-modal-edit-sell-offer-body-actions">
                <Button
                  label={t("pages.default.offerOperations.sendToOrder")}
                  type="primary"
                  onClick={modalSellOfferToggle}
                />
              </div>
            </>
          )}
        </div>
      </Modal>
      {inspectedCertificateId && (
        <ModalCertificate
          t={t}
          certificateId={inspectedCertificateId}
          isOpen={inspectedCertificateId ? true : false}
          toggle={() => setInspectedCertificateId()}
          difCalculate={true}
        />
      )}
    </>
  );
}
